import { execAdmin } from '../utils';

export type TemplateFormat = 'csv' | 'tsv';

interface GetCatalogUploadTemplateVariables {
  partnerCode: string;
  format?: string;
}

interface GetCatalogUploadTemplateResponse {
  catalogUploadTemplate: string | null;
}

const CATALOG_UPLOAD_TEMPLATE_QUERY = `
  query getCatalogUploadTemplate($partnerCode: String!, $format: String) {
    catalogUploadTemplate(partnerCode: $partnerCode, format: $format)
  }
`;

/**
 * Downloads a catalog upload template file for a partner.
 * @param partnerCode - The partner code to generate template for
 * @param format - File format ('csv' or 'tsv'), defaults to 'csv'
 */
export const getCatalogUploadTemplate = async (
  partnerCode: string,
  format: TemplateFormat = 'csv'
): Promise<void> => {
  const data = await execAdmin<GetCatalogUploadTemplateVariables, GetCatalogUploadTemplateResponse>(
    CATALOG_UPLOAD_TEMPLATE_QUERY,
    {
      variables: {
        partnerCode,
        format,
      }
    },
  );

  const downloadUrl = data.catalogUploadTemplate;

  if (!downloadUrl) {
    throw new Error('No template download URL available');
  }

  // Validate URL is HTTPS for security
  if (!downloadUrl.startsWith('https://')) {
    throw new Error('Invalid download URL: must use HTTPS');
  }

  // Open the download URL in a new window/tab
  window.open(downloadUrl, '_blank');
};
